export class EnvironmentBase {
  public buildVersion = 'v.0.1';
  public mock = false;
  public apiUrl = 'http://localhost:8080/api';
  public production = true;
  public baseUrl = '';
  public asgAdminUrl = '/asg-admin';
  public asgSecurityUrl = '/asg-security';
  public asgiOrchUrl = '/asg-iorchestrate';
  public serviceUrl = '/esbservice';
  public iformWebformAPIUrl = "/Iforms-webforms-app";
  public mappingToolAPIUrl = '/Iforms-mappingtool-app';
  public pdf2htmlAPIUrl = '/iforms-pdf2html-app';
  public mlValidationUrl = '/iforms-mlvalidation-app';
  public customModelsAPIUrl= '/transcriber-custom-models-api';
  public formsDownloadUrl = '/';
}
